import { render, staticRenderFns } from "./PermissionTest.vue?vue&type=template&id=72125d27&scoped=true&"
import script from "./PermissionTest.vue?vue&type=script&lang=js&"
export * from "./PermissionTest.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTest.vue?vue&type=style&index=0&id=72125d27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72125d27",
  null
  
)

export default component.exports